import script from "./MainFrontLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./MainFrontLayout.vue?vue&type=script&setup=true&lang=js"

import "./MainFrontLayout.vue?vue&type=style&index=0&id=7bf31678&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bf31678"]])

export default __exports__